export default __webpack_public_path__ + "static/media/parent_new.39f1cdce.svg";